import React, { createRef, useEffect, useState } from "react";
import { RouteComponentProps } from "@reach/router";
import slugify from "slugify";
import ReactMarkdown from "react-markdown";

import ContentDetails from "./details";

export { ContentDetails };
